import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Popper } from '@mui/material';
import { FindLoad, FindSuccessItem, Images } from 'utils';
import { CloseButton, MinLoader } from 'components';
import { httpRequestsOnSuccessActions, formActions } from 'store';
import { formBuilderStatusEnums } from '../constants';

const ACTION_TYPE = 'EDIT_FORM';
const LOAD_ACTON_TYPE = 'GET_FORM_BY_ID';
export const FormStatusBox = ({ info }) => {
    const dispatch = useDispatch();
    const [anchorEl, setAnchorEl] = useState(null);
    const openStatus = Boolean(anchorEl);
    const id = openStatus ? 'simple-popper' : undefined;
    const [selected, setSelected] = useState('');
    const loader = FindLoad(ACTION_TYPE);
    const loadForm = FindLoad(LOAD_ACTON_TYPE);
    const success = FindSuccessItem(ACTION_TYPE);
    const formById = useSelector((state) => state.forms.form);

    useEffect(() => {
        if(success){
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
            setSelected('');
        }
    }, [success]);
    
    const handleClick = (event) => {
        dispatch(formActions.getFormById(info?.id));
        event.preventDefault();
        event.stopPropagation();
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    const renderColorAndText = (status) => {
        switch (status) {
            case formBuilderStatusEnums.PUBLISHED:
                return {
                    filter: 'brightness(0) saturate(100%) invert(34%) sepia(82%) saturate(946%) hue-rotate(117deg) brightness(91%) contrast(98%)',
                    backgroundColor: '#ECFDF3',
                    circleColor: '#12B76A',
                    color: '#027A48',
                    text: 'Published',
                    value: formBuilderStatusEnums.PUBLISHED,
                };
            case formBuilderStatusEnums.UNPUBLISHED:
                return {
                    filter: 'brightness(0) saturate(100%) invert(19%) sepia(23%) saturate(816%) hue-rotate(179deg) brightness(99%) contrast(85%)',
                    backgroundColor: '#F5F5F5',
                    circleColor: '#717680',
                    color: '#414651',
                    text: 'Unpublished',
                    value: formBuilderStatusEnums.UNPUBLISHED,
                };
            default:
                return { backgroundColor: '', circleColor: '', color: '', text: '' };
        }
    };

    const { filter, backgroundColor, circleColor, color, text } = renderColorAndText(info?.status || formBuilderStatusEnums.PUBLISHED);

    const statuses = [
        { ...renderColorAndText(formBuilderStatusEnums.PUBLISHED) },
        { ...renderColorAndText(formBuilderStatusEnums.UNPUBLISHED) },
    ];

    const handleChangeStatus = (ev) => {
        setAnchorEl(null);
        setSelected(info);
        const payload = { ...formById };
        payload.status = ev?.value;
        if(formById?.models?.length) {
            payload.models = formById?.models[0];
            payload.model = formById?.models[0];
        }
        dispatch(formActions.editForm(info?.id, payload));
    };

    return (
        <div>
            <div className="flex-align-center" style={{ gap: 8 }}>
                <button
                    aria-describedby={id}
                    onClick={handleClick}
                    className="status-card-box"
                    style={{ backgroundColor: backgroundColor, border: 'none', height: 28 }}
                >
                    {text && <div style={{ backgroundColor: circleColor }} />}
                    <p style={{ color: color }}>{text ? text : '--'}</p>
                    {selected?.id === info?.id && loader?.length ? (
                        <MinLoader height={18} width={18} color={circleColor} margin={'0'} position={'relative'} />
                    ) : (
                        <img style={{ filter: filter }} src={Images.dropdownArrow} alt="" />
                    )}
                </button>
            </div>

            <Popper
                id={id}
                open={openStatus}
                anchorEl={anchorEl}
                className="status-popper-box"
                placement="bottom-start"
                style={{ position: 'absolute', zIndex: 1500 }}
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                }}
            >
                <div>
                    <div className="status-popper-header">
                        <p>Update Status</p>
                        <CloseButton handleCLic={handleClick} />
                    </div>
                    <div className="status-popper-body">
                        {statuses?.map((i, j) => (
                            <button
                                disabled={loadForm?.length}
                                key={j}
                                onClick={() => handleChangeStatus(i)}
                                className="status-card-box"
                                style={{ backgroundColor: 'transparent', border: 'none', opacity: loadForm?.length ? 0.5 : 1 }}
                            >
                                <div style={{ backgroundColor: i?.circleColor }} />
                                <p style={{ color: i?.color }}>{i?.text}</p>
                                {loadForm?.length &&
                                    <MinLoader height={18} width={18} color={i?.circleColor} margin={'0'} position={'relative'}  />
                                }
                            </button>
                        ))}
                    </div>
                </div>
            </Popper>
            {openStatus && (
                <div
                    className="beck-drop"
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setAnchorEl(null);
                    }}
                />
            )}
        </div>
    );
};
